import { provideSingleton, lazyInject } from './inversify';
import { initErrorCatching, setUserForError } from '../core/system/GlobalErrorCatching';
import { callUrlStream } from './callUrlStream';

@provideSingleton(ApiService)

export class ApiService {

  public static unternehmenInternal: any;
  public static callList: Array<any> = [];
  public static bereichKey: string;
  public static module: string;

  constructor() {
    const conf = require('../wips.config');
    if (!conf.disableErrorCatching) {
      initErrorCatching();
    }
    this.allowOverride = conf.allowOverride;
    this.url = conf.api_url;
    this.call = this.call.bind(this);
    this.setLogoutNotifier = this.setLogoutNotifier.bind(this);
    this.setUsername = this.setUsername.bind(this);
    this.setErrLog = this.setErrLog.bind(this);
    this.getErrLog = this.getErrLog.bind(this);
  }

  private url: any;
  private allowOverride?: boolean;
  private logoutNotifier: () => void = null;
  private username: string = null;
  private bereich_key: string = null;
  private multi_bereich_keys: Array<any> = [];
  private userTid: number = null;
  private access_token: string;
  private errorLog: Array<any> = [];
  private MAX_LOG_LENGTH = 1000;
  private serverState = false;
  private config = require('../wips.config.js');
  private mandant_key: string = null;
  private adminFlag = false;
  private beraterFlag = false;
  private ajaxTimeout = 300000; // 5 Min
  private userLoginData: any = {};
  private errorCallback: (err: any) => void;

  setUserLoginData(userLoginData: any) {
    this.userLoginData = { ...(userLoginData || {}) };
  }
  getUserLoginData() {
    return { ...this.userLoginData };
  }
  userHasMultiTools() {
    if (!this.isAdmin() && !this.isBerater()) {
      const login = this.getUserLoginData();
      if (login) {
        if (login.multi_tools) {
          return true;
        }
        if (Array.isArray(login.as_mandanten_user_of) && login.as_mandanten_user_of.length > 1) {
          return true;
        }
      }
    }
    return false;
  }
  setUsername(username: string) {
    this.username = username;
    setUserForError(username);
    // Error-Test
    // const a: any = {};
    // alert(a.b.c);
  }
  getUsername() {
    return this.username ? this.username : null;
  }
  setBereichKey(bereich_key: string) {
    this.bereich_key = bereich_key;
    ApiService.bereichKey = bereich_key;
  }
  getBereichKey() {
    return this.bereich_key;
  }
  setMultiBereichKeys(multi_bereich_keys: Array<string>) {
    this.multi_bereich_keys = Array.isArray(multi_bereich_keys) ? multi_bereich_keys : [];
  }
  getMultiBereichKeys() {
    return [...this.multi_bereich_keys];
  }
  setUnternehmenInternal(unternehmen: any) {
    ApiService.unternehmenInternal = unternehmen;
  }
  setUserTid(userTid: number) {
    this.userTid = userTid;
  }
  getUserTid() {
    return this.userTid;
  }
  isMainUser(): boolean {
    const login = this.getUserLoginData() || {};
    const regi = ApiService.unternehmenInternal || {};
    const isMainUser: boolean = login.mail && regi.mail ? login.mail === regi.mail : false;
    return !this.isAdmin() && !this.isBerater() && isMainUser;
  }
  isMandantenUser(): boolean {
    return !this.isAdmin() && !this.isBerater() && !this.isMainUser();
  }
  isLoginOfMandantenUser(): boolean {
    const login = this.getUserLoginData() || {};
    return !!login.login_of_mandanten_user;
  }
  setAdminFlag(b: boolean) {
    this.adminFlag = b;
  }
  isAdmin(): boolean {
    return this.adminFlag;
  }
  setBeraterFlag(b: boolean) {
    this.beraterFlag = b;
  }
  isBerater(): boolean {
    return this.beraterFlag;
  }
  setMandantKey(mandant_key: string) {
    this.mandant_key = mandant_key;
  }
  getMandantKey() {
    return this.mandant_key;
  }
  setToken(access_token: string) {
    this.access_token = access_token;
  }
  getToken() {
    return this.access_token;
  }
  setTokenLocalStorage() {
    localStorage.setItem('access_token', this.access_token);
  }
  getTokenLocalStorage() {
    return localStorage.getItem('access_token');
  }
  removeTokenLocalStorage() {
    return localStorage.removeItem('access_token');
  }
  setLogoutNotifier(notifier: () => void) {
    // console.log('Setting logout-notifier ... ' + notifier);
    this.logoutNotifier = notifier;
  }
  crypt(input: string, key: string) {
    const output = [];
    let charCode;
    for (let i = 0; i < input.length; i++) {
      charCode = input.charCodeAt(i) ^ key[i % key.length].charCodeAt(0);
      output.push(String.fromCharCode(charCode));
    }
    return output.join('');
  }
  async async_call(callName: string, dataParams: any, module?: string) {
    const defaultData = {
      mod_state: callName,
      sid: sessionStorage.getItem('LOGIN_SID'),
      // WKETOOL-147: "ReferenceError: sessionStorage is not defined"
      // sid: null as any,
      module: module,
      access_token: this.access_token,
      adminFlag: this.adminFlag ? 1 : 0,
      beraterFlag: this.beraterFlag ? 1 : 0
    };
    const that = this;
    let sendData: any;
    if (dataParams) {
      if (!this.allowOverride) {
        delete (dataParams.override);
      }
      if (!dataParams.user) {
        dataParams.user = (this.username === null) ? sessionStorage.getItem('LOGIN_USER') : this.username;
        // WKETOOL-147: "ReferenceError: sessionStorage is not defined"
        // dataParams.user = this.username || 'unknown';
      }
      sendData = { ...defaultData, ...dataParams };
    } else {
      sendData = defaultData;
    }

    sendData.bereich_key = dataParams.bereich_key || this.bereich_key;

    // WKBER-95: Alternative Speicherung von Dateien als SFTP / FTP
    if (this.config.save_file_ftp) {
      sendData.save_file_ftp = this.config.save_file_ftp;
    }

    // Nur für Admin-User / Berater, um am Server einen Mandant anzugeben
    if (this.isAdmin() || this.isBerater()) {
      sendData.mandant_key = this.mandant_key;
    }
    this.setCallInfo(this.url, sendData);

    // WKBER-89: Verschlüsselungsmechanismus für API-Calls
    if (this.config.encryptApiCalls && typeof this.config.cryptKey === 'string') {
      const key = (this.access_token ? this.access_token : '') + this.config.cryptKey;
      const base64Json = btoa(encodeURIComponent(JSON.stringify(sendData)));
      const encryptedJson = this.crypt(base64Json, key);
      // console.log('API Call Encrypted', '-', callName);
      sendData = {
        encrypted: true,
        encryptedJson
      };
    }

    // Authentifizierung und Mandant aus Token entnehmen
    // Token darf nicht verschlüsselt werden
    sendData.access_token = this.access_token;

    // console.log(sendData);

    const url = this.url;
    const call = callName;
    return $.ajax({
      method: 'POST',
      url: url,
      data: sendData,
      timeout: this.ajaxTimeout,
      error: (xhr, status) => {
        that.setErrLog(xhr, status, url, sendData);
        if (xhr.status === 401) {
          if (that.logoutNotifier) {
            that.logoutNotifier();
            if (call !== 'doLogin') {
              alert('Ihre Sitzung ist abgelaufen!');
            }
          } else {
            console.log('Kein Logout-Notifier');
          }
        }
      }
    })
      .done(function (data: string) {
        that.setServerState(true);
        // Entschlüsselungsmechanismus für getStructure
        if (that.config.encryptApiCalls && typeof that.config.cryptKey === 'string' && callName === 'getStructure') {
          const key = (that.access_token ? that.access_token : '') + that.config.cryptKey;
          const encryptedJson = atob(data);
          data = that.crypt(encryptedJson, key);
        }
      })
      .fail(function (xhr, status) {
        that.setServerState(false);
        that.setErrLog(xhr, status, url, sendData);
      });
  }
  call(callName: string, dataParams: any, callback: (data: string, suc: boolean) => void, module?: string) {
    const defaultData = {
      mod_state: callName,
      sid: sessionStorage.getItem('LOGIN_SID'),
      // WKETOOL-147: "ReferenceError: sessionStorage is not defined"
      // sid: null as any,
      module: module,
      access_token: this.access_token,
      adminFlag: this.adminFlag ? 1 : 0,
      beraterFlag: this.beraterFlag ? 1 : 0
    };
    const that = this;
    let sendData: any;
    if (dataParams) {
      if (!this.allowOverride) {
        delete (dataParams.override);
      }
      if (!dataParams.user) {
        dataParams.user = (this.username === null) ? sessionStorage.getItem('LOGIN_USER') : this.username;
        // WKETOOL-147: "ReferenceError: sessionStorage is not defined"
        // dataParams.user = this.username || 'unknown';
      }
      sendData = { ...defaultData, ...dataParams };
    } else {
      sendData = defaultData;
    }

    sendData.bereich_key = dataParams.bereich_key || this.bereich_key;

    // WKBER-95: Alternative Speicherung von Dateien als SFTP / FTP
    if (this.config.save_file_ftp) {
      sendData.save_file_ftp = this.config.save_file_ftp;
    }

    // Nur für Admin-User / Berater, um am Server einen Mandant anzugeben
    if (this.isAdmin() || this.isBerater() || this.userHasMultiTools()) {
      sendData.mandant_key = this.mandant_key;
    }

    // WKETOOL-110: Login mit doppelten Mail-Adressen
    if (this.userHasMultiTools()) {
      sendData.override_mandant_key = 1;
    }

    this.setCallInfo(this.url, sendData);

    // WKBER-89: Verschlüsselungsmechanismus für API-Calls
    if (this.config.encryptApiCalls && typeof this.config.cryptKey === 'string') {
      const key = (this.access_token ? this.access_token : '') + this.config.cryptKey;
      const base64Json = btoa(encodeURIComponent(JSON.stringify(sendData)));
      const encryptedJson = this.crypt(base64Json, key);
      // console.log('API Call Encrypted', '-', callName);
      sendData = {
        encrypted: true,
        encryptedJson
      };
    }

    // Authentifizierung und Mandant aus Token entnehmen
    // Token darf nicht verschlüsselt werden
    sendData.access_token = this.access_token;

    /* <WKETOOL-147> */
    const rbracket = /\[\]$/;
    const class2type: any = {};
    // Populate the class2type map
    'Boolean Number String Function Array Date RegExp Object Error Symbol'.split(' ').forEach((name: string) => {
      class2type[`[object ${name}]`] = name.toLowerCase();
    });
    const toType = (obj: any) => {
      if (obj == null) {
        return obj + '';
      }
      // Support: Android <=2.3 only (functionish RegExp)
      return typeof obj === 'object' || typeof obj === 'function'
        ? class2type[toString.call(obj)] || 'object'
        : typeof obj;
    };
    const buildParams = (prefix: any, obj: any, traditional: any, add: any) => {
      var name;

      if (Array.isArray(obj)) {
        // Serialize array item.
        obj.forEach((v: string, i: number) => {
          if (traditional || rbracket.test(prefix)) {
            // Treat each array item as a scalar.
            add(prefix, v);
          } else {
            // Item is non-scalar (array or object), encode its numeric index.
            buildParams(
              `${prefix}[${(typeof v === 'object' && v != null ? i : '')}]`,
              v,
              traditional,
              add
            );
          }
        });
      } else if (!traditional && toType(obj) === 'object') {
        // Serialize object item.
        for (name in obj) {
          buildParams(`${prefix}[${name}]`, obj[name], traditional, add);
        }
      } else {
        // Serialize scalar item.
        add(prefix, obj);
      }
    };
    const param = (a: any, traditional: boolean) => {
      var prefix,
        s: any[] = [],
        add = function (key: any, valueOrFunction: any) {
          // If value is a function, invoke it and use its return value
          var value = typeof valueOrFunction === 'function'
            ? valueOrFunction() : valueOrFunction;

          s[s.length] = encodeURIComponent(key) + '=' + encodeURIComponent(value == null ? '' : value);
        };

      if (a == null) {
        return '';
      }
      // // If an array was passed in, assume that it is an array of form elements.
      // if (Array.isArray(a) || (a.jquery && !jQuery.isPlainObject(a))) {

      // 	// Serialize the form elements
      // jQuery.each( a, function () {
      // 	add(this.name, this.value);
      // } );

      // } else {
      // If traditional, encode the "old" way (the way 1.3.2 or older
      // did it), otherwise encode params recursively.
      for (prefix in a) {
        buildParams(prefix, a[prefix], traditional, add);
      }
      // }

      // Return the resulting serialization
      return s.join('&');
    };
    /* </WKETOOL-147> */
    const url = this.url;
    const call = callName;
    /* <WKETOOL-147> */
    const body = param(sendData, false).replace(/%20/g, '+');
    const https = require('https');
    const urlApi = new URL(url);
    let data: string = '';
    const req: any = https.request(
      {
        hostname: urlApi.hostname,
        port: 443,
        path: urlApi.pathname,
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF8',
          'Content-Length': Buffer.byteLength(body)
        },
      },
      (res: any) => {
        console.log(`STATUS: ${res.statusCode}`);
        // console.log(`HEADERS: ${JSON.stringify(res.headers)}`);
        if (res.statusCode !== 200) {
          callback('ERROR', false);
          return;
        }
        res.setEncoding('utf8');
        res.on('data', (chunk: any) => {
          // console.log(`BODY: ${chunk}`);
          data += chunk;
        }).on('end', () => {
          // console.log('No more data in response.');
          that.setServerState(true);
          // Entschlüsselungsmechanismus für getStructure
          if (that.config.encryptApiCalls && typeof that.config.cryptKey === 'string' && callName === 'getStructure') {
            const key = (that.access_token ? that.access_token : '') + that.config.cryptKey;
            const encryptedJson = atob(data);
            const json = that.crypt(encryptedJson, key);
            callback(json, true);
            return;
          }
          callback(data, true);
        });
      }).on('error', (error: any) => {
        console.error(`problem with request: ${error.message}`);
        that.setServerState(false);
        callback(null, false);
      });
    // Write data to request body
    // req.write(body); // WKETOOL-147: statt $.ajax()
    // req.end(); // WKETOOL-147: statt $.ajax()
    /* </WKETOOL-147> */

    // console.log(sendData);

    $.ajax({
      method: 'POST',
      url: url,
      data: sendData,
      timeout: this.ajaxTimeout,
      error: (xhr, status) => {
        that.setErrLog(xhr, status, url, sendData);
        if (xhr.status === 401) {
          if (that.logoutNotifier) {
            that.logoutNotifier();
            if (call !== 'doLogin') {
              alert('Ihre Sitzung ist abgelaufen!');
            }
          } else {
            console.log('Kein Logout-Notifier');
          }
        }
        callback('ERROR', false);
      }
    })
      .done(function (data: string) {
        that.setServerState(true);
        // Entschlüsselungsmechanismus für getStructure
        if (that.config.encryptApiCalls && typeof that.config.cryptKey === 'string' && callName === 'getStructure') {
          const key = (that.access_token ? that.access_token : '') + that.config.cryptKey;
          const encryptedJson = atob(data);
          const json = that.crypt(encryptedJson, key);
          callback(json, true);
          return;
        }
        callback(data, true);
      })
      .fail(function (xhr, status) {
        that.setServerState(false);
        that.setErrLog(xhr, status, url, sendData);
        callback(null, false);
      });
  }

  callUrl(url: string, callback: (data: string, suc: boolean) => void, sendData?: any) {
    this.setCallInfo(url, sendData);
    const that = this;
    $.ajax({
      method: 'POST',
      url: url,
      data: sendData,
      timeout: this.ajaxTimeout,
      error: (xhr, status) => {
        that.setErrLog(xhr, status, url, '');
        if (xhr.status === 401) {
          if (that.logoutNotifier) {
            that.logoutNotifier();
          } else {
            console.log('Kein Logout-Notifier');
          }
        }
      }
    })
      .done(function (data: string) {
        callback(data, true);
        // if (that.logoutNotifier) {
        //   // ACHTUNG, HIER NUR TEST, NICHT AKTI
        //   that.logoutNotifier();
        //   alert('Ihre Sitzung ist abgelaufen!');
        // }
      })
      .fail(function (xhr, status) {
        that.setErrLog(xhr, status, url, sendData);
        callback(null, false);
      });
  }

  callStream(url: string, sendData: string, callback: (str: string) => void, callbackDone: (data: string, suc: boolean) => void) {
    callUrlStream(url, sendData, callback, callbackDone);
  }

  setCallInfo(url: string, data: any) {
    ApiService.callList.push({ url, data });
    if (ApiService.callList.length > 50) {
      ApiService.callList.shift();
    }
  }

  setErrLog(xhr: any, status: any, url: string, data: any) {
    this.errorLog.push({
      xhr, status, url, data, date: new Date()
    });
    if (this.errorLog.length > this.MAX_LOG_LENGTH) {
      this.errorLog.shift();
    }
    if (typeof this.errorCallback === 'function') {
      this.errorCallback({ xhr, status, url, data });
    }
  }

  getErrLog() {
    return this.errorLog;
  }

  getServerState() {
    return this.serverState;
  }

  setServerState(state: boolean) {
    this.serverState = state;
  }

  setErrCallback(callback: (err: any) => void) {
    this.errorCallback = callback;
  }
}
